import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type OpeningHoursResponse} from './opening-hours-data';

export function openingHoursTypePatcher(data: OpeningHoursResponse): RestTypeWithTypename<OpeningHoursResponse> {
    return {
        __typename: 'OpeningHoursData',
        openingHours: data.openingHours.map(openingHour => ({
            __typename: 'OpeningHour',
            ...openingHour,
        })),
        behaviors: data.behaviors.map(behavior => ({
            __typename: 'OpeningHourBehavior',
            ...behavior,
        })),
    };
}
